import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eed81886"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Contact" }
const _hoisted_2 = {
  class: "Contact-intro padded",
  "data-scroll-section": ""
}
const _hoisted_3 = { class: "Contact-intro-title h1 h1--big" }
const _hoisted_4 = {
  class: "Contact-content grid padded",
  "data-scroll-section": ""
}
const _hoisted_5 = { class: "Contact-content-left" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "Contact-content-right" }
const _hoisted_8 = { class: "Contact-form-row" }
const _hoisted_9 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Last Name", -1))
const _hoisted_11 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_12 = { class: "Contact-form-row" }
const _hoisted_13 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_14 = {
  value: "",
  selected: ""
}
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form__arrow" }, null, -1))
const _hoisted_17 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_18 = { class: "Contact-form-instruction text" }
const _hoisted_19 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_20 = { class: "Contact-form-foot" }
const _hoisted_21 = {
  key: 0,
  type: "button",
  disabled: "",
  class: "button button--correct"
}
const _hoisted_22 = {
  key: 1,
  type: "button",
  disabled: "",
  class: "button button--valid"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "14",
  height: "10",
  viewBox: "0 0 14 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M13.697.283a1 1 0 0 1 .02 1.414l-7.775 8a1 1 0 0 1-1.434 0L.283 5.349a1 1 0 1 1 1.434-1.394l3.508 3.61L12.283.303a1 1 0 0 1 1.414-.02Z",
    fill: "#fff"
  })
], -1))
const _hoisted_24 = {
  key: 0,
  class: "error-msg error-msg--alt error-msg--right t-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_UploadButton = _resolveComponent("UploadButton")!
  const _component_ButtonHover = _resolveComponent("ButtonHover")!
  const _component_ErrorPopin = _resolveComponent("ErrorPopin")!
  const _component_LayoutNotConnected = _resolveComponent("LayoutNotConnected")!

  return (_openBlock(), _createBlock(_component_LayoutNotConnected, null, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('contact.title')), 1)
        ]),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", {
              class: "text-lg",
              innerHTML: _ctx.$t('contact.description')
            }, null, 8, _hoisted_6),
            _createVNode(_component_RouterLink, {
              to: "/faq",
              class: "Contact-content-left-link link-secondary text-lg"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('contact.faqs-link')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("form", {
              class: "Contact-form form",
              onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("legend", null, _toDisplayString(_ctx.$t('contact.first-name')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.firstname) = $event)),
                    onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.firstname.$touch && _ctx.v$.firstname.$touch(...args))),
                    class: _normalizeClass({ 'error': _ctx.v$.firstname.$errors.length }),
                    type: "text",
                    name: "firstname",
                    minlength: "2",
                    required: "",
                    spellcheck: "false",
                    autocorrect: "off"
                  }, null, 34), [
                    [
                      _vModelText,
                      _ctx.firstname,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.firstname.$errors.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.v$.firstname.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("fieldset", null, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.lastname) = $event)),
                    onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.v$.lastname.$touch && _ctx.v$.lastname.$touch(...args))),
                    class: _normalizeClass({ 'error': _ctx.v$.lastname.$errors.length }),
                    type: "text",
                    name: "lastname",
                    minlength: "2",
                    required: "",
                    spellcheck: "false",
                    autocorrect: "off"
                  }, null, 34), [
                    [
                      _vModelText,
                      _ctx.lastname,
                      void 0,
                      { trim: true }
                    ]
                  ]),
                  (_ctx.v$.lastname.$errors.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.v$.lastname.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("legend", null, _toDisplayString(_ctx.$t('contact.email')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.email) = $event)),
                    onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.v$.email.$touch && _ctx.v$.email.$touch(...args))),
                    class: _normalizeClass({ 'error': _ctx.v$.email.$errors.length }),
                    type: "email",
                    name: "email",
                    required: "",
                    spellcheck: "false",
                    autocapitalize: "off",
                    autocorrect: "off"
                  }, null, 34), [
                    [_vModelText, _ctx.email]
                  ]),
                  (_ctx.v$.email.$errors.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.v$.email.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("fieldset", null, [
                  _createElementVNode("legend", null, _toDisplayString(_ctx.$t('contact.question')), 1),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.about) = $event)),
                    onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.v$.about.$touch && _ctx.v$.about.$touch(...args))),
                    class: _normalizeClass({ 'error': _ctx.v$.about.$errors.length }),
                    name: "about"
                  }, [
                    _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t('register-form.select')), 1),
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                      return _createElementVNode("option", {
                        key: n,
                        value: _ctx.$t('contact.item'+n)
                      }, _toDisplayString(_ctx.$t('contact.item'+n)), 9, _hoisted_15)
                    }), 64))
                  ], 34), [
                    [_vModelSelect, _ctx.about]
                  ]),
                  _hoisted_16,
                  (_ctx.v$.about.$errors.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.v$.about.$errors[0].$message), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("fieldset", null, [
                _createElementVNode("legend", null, _toDisplayString(_ctx.$t('contact.comment')), 1),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.message) = $event)),
                  onBlur: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.v$.message.$touch && _ctx.v$.message.$touch(...args))),
                  class: _normalizeClass({ 'error': _ctx.v$.message.$errors.length }),
                  name: "message",
                  required: "",
                  cols: "10",
                  rows: "12",
                  maxlength: "800"
                }, null, 34), [
                  [_vModelText, _ctx.message]
                ]),
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('contact.max')), 1),
                (_ctx.v$.message.$errors.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(_ctx.v$.message.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_UploadButton, {
                  ref: "upload",
                  onOnFileChange: _ctx.onFileChange,
                  legend: _ctx.$t('contact.attach'),
                  cta: _ctx.$t('contact.upload-cta')
                }, null, 8, ["onOnFileChange", "legend", "cta"]),
                _createElementVNode("div", null, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("button", _hoisted_21, _toDisplayString(_ctx.$t('register-form.loading')), 1))
                    : (_ctx.isSent)
                      ? (_openBlock(), _createElementBlock("button", _hoisted_22, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('contact.sent-cta')), 1),
                          _hoisted_23
                        ]))
                      : (_openBlock(), _createBlock(_component_ButtonHover, {
                          key: 2,
                          type: "submit",
                          class: "button"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('contact.submit-cta')), 1)
                          ]),
                          _: 1
                        }))
                ])
              ]),
              (_ctx.errors)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (item, i) => {
                      return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(item), 1))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_ErrorPopin, { active: _ctx.errorRequest }, null, 8, ["active"])
            ], 32)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}